import './myDepositsSection.scss';
// @ vendors
import PropTypes from 'prop-types';
import React from 'react';
// @ commons
const { FormattedText, formatText } = require('core/i18n').i18n;
const { OKLink } = require('commonsComponents/OKLink');
const { ContentBox } = require('commonsComponents/contentBox');
// @ constants
import { MINIMUM_DEPOSITS_TO_BE_SHOWN } from '../../constants/depositsView';

const myDepositsSection = ({
    showAllDeposits,
    handleLoadMoreClick,
    filteredSize,
    lastOfferIndex,
    children
}) => {
    const moreDepositsLinkText = showAllDeposits ? 'deposits-deposits_yourDepositsSectionSeeLess' : 'deposits-deposits_yourDepositsSectionSeeMore';
    const footerText = formatText(moreDepositsLinkText);
    const depositsTitle = <FormattedText value="deposits-deposits_yourDepositsSectionTitle"/>
    const depositsTitleCounter = ` (${filteredSize})`;
    const icon = "rebrand-savings";
    const classNameHeaderTitle = `my-deposits-section__card-header-title-icon icon ${icon}`;
    const footer = filteredSize > MINIMUM_DEPOSITS_TO_BE_SHOWN && lastOfferIndex < filteredSize ?
      (<section className="my-deposits-section__card-footer-link-container">
          <OKLink modifier="widget" onClick={() => handleLoadMoreClick()}>{footerText}</OKLink>
      </section>) : null;
      const toReturn = filteredSize > 0 ? (
        <React.Fragment>
            <div className="my-deposits-section__body-container">
                <ContentBox>
                    <div className="container-fluid">
                        <div className="my-deposits-section__card-header row">
                            <div>
                                <div className="my-deposits-section__card-header-title-container">
                                    <i className={classNameHeaderTitle}></i>
                                    {depositsTitle} 
                                    <span className="my-deposits-section__card-header-title-counter">{depositsTitleCounter}</span>
                                </div>
                            </div>
                            <div>
                                <ul className="my-deposits-section__card-header-cols">
                                    <li className="my-deposits-section__card-header-cols-item"><span>{formatText('deposits-deposits_yourDepositsSectionExpirationDate')}</span></li>
                                    <li className="my-deposits-section__card-header-cols-item"><span>{formatText('deposits-deposits_yourDepositsSectionAmount')}</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    {children}
                </ContentBox>
            </div>
            {footer}
        </React.Fragment>) : (
            <div className="my-deposits-section__body-container">
                {children}
            </div>
        )
    return (
        <section className="my-deposits-section row">
            {toReturn}
        </section>
    );
  }

myDepositsSection.propTypes = {
    showAllDeposits: PropTypes.bool,
    handleLoadMoreClick: PropTypes.func,
    filteredSize: PropTypes.number,
    children: PropTypes.node,
    lastOfferIndex: PropTypes.number,
};

  export default myDepositsSection;